// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2BsSh","tab":"ProcedureTabs_tab__RuKov"};